<template>
    <div class="intent">
        <Banner :list="bannerList" :height="186" :showBtn="false" class="head-banner"></Banner>

        <!--
        <div class="intent-block step">
            <div class="step-img" v-if="step == 1">
                <img src="@/../static/liucheng1.png" />
            </div>
            <div class="step-img" v-if="step == 2">
                <img src="@/../static/liucheng2.png" />
            </div>
            <div class="step-img" v-if="step == 3">
                <img src="@/../static/liucheng3.png" />
            </div>
        </div>-->

        <div class="intent-block user-block" v-for="(item, index) in userList" :key="index" >
            <div class="intent-title">
                <span><img src="@/../static/title_left.png"></span>
                第{{convertToChinaNum(index+1)}}人
                <span><img src="@/../static/title_right.png"></span>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    参赛者名字：
                </div>
                <div class="control-input">
                    <input type="text" :name="'username'+index" v-validate="'required|name'" class="form-control" placeholder="请输入参赛者名字" v-model="item.username" />
                    <span v-show="errors.has('username'+index)" class="error-text">{{errors.first('username'+index)}}</span>
                </div>
            </div>

             <div class="control-block row">
                <div class="control-label">
                    证件类型：
                </div>
                <div class="control-input">
                    <select class="form-control" v-model="item.cardType">
                        <option v-for="(cardType, i) in cardTypes" :value="i" :key="i">{{cardType}}</option>
                    </select>
                </div>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    证件号码：
                </div>
                <div class="control-input">
                    <input type="text" v-validate="{'required':true, 'idcard':(item.cardType==0), 'passportcard':(item.cardType==1), 'hkcard':(item.cardType==2), 'twcard':(item.cardType==3)}" class="form-control" :name="'idcard'+index" placeholder="请输入证件号码" v-model="item.cardNumber"/>
                    <span v-show="errors.has('idcard'+index)" class="error-text">{{errors.first('idcard'+index)}}</span>
                </div>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别：
                </div>
                <div class="control-input">
                    <div class="form-control radio-inline">
                        <input type="radio" class=""  value="0" v-if="item.sex==0" checked  v-model="item.sex"/>
                        <input type="radio" class=""  value="0" v-else v-model="item.sex"/>
                        男
                        <input type="radio" class="" value="1" v-if="item.sex==1" checked  v-model="item.sex"/>
                        <input type="radio" class=""  value="1" v-else  v-model="item.sex"/>女
                    </div>
                </div>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    出生日期：
                </div>
                <div class="control-input">
                    
                    <mt-datetime-picker ref="picker" type="date" v-model="selectedDate" 
                        @confirm="dateConfirm(index)"
                        :startDate="new Date('1900-01-01')"
                        :endDate="new Date()"
                        year-format="{value} 年"
                        month-format="{value} 月"
                        date-format="{value} 日"></mt-datetime-picker>
                    <input type="input" ref="pickerInput" :name="'birthDay'+index"  class="form-control" placeholder="请选择出生日期" v-model="item.birthDay" readonly  @click="datePicker(index)"/>
                    <span v-show="errors.has('birthDay'+index)" class="error-text">{{errors.first('birthDay'+index)}}</span>

                </div>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    手机号码：
                </div>
                <div class="control-input">
                    <input type="number" v-validate="'required|phone'" :name="'phone'+index" class="form-control" placeholder="请输入您的手机号码" v-model="item.mobile"/>
                    <span v-show="errors.has('phone'+index)" class="error-text">{{errors.first('phone'+index)}}</span>
                </div>
            </div>

            

            <div class="control-block row">
                <div class="control-label">
                    报名方式：
                </div>
                <div class="control-input">
                        <div class="form-control radio-row">
                            <label v-for="(fee,i) in station.fees" :key="i" v-if="fee.status">
                                <input type="checkbox" class=""  :value="fee.feeId"  v-model="item.feeId" :name="'fee'+index"  v-validate="'required'"/>
                                {{fee.name}}¥{{fee.price}}元*1份
                            </label>
                        </div>
                        <span v-show="errors.has('fee'+index)" class="error-text">{{errors.first('fee'+index)}}</span>

                </div>
            </div>

            
            <div v-if="item.extra && item.extra.length > 0">
                <div class="control-block row" v-for="(field, idx) in item.extra" :key="idx" >
                    <div class="control-label">
                        {{field.name}}：
                    </div>
                    <div class="control-input">
                        <!-- 0: 单行文本  1： 多行文本  2： 单选  3： 多选 4：文件-->
                        <input type="text" :name="field.name + '_' + index + '_' + idx" v-if="field.type==0" v-validate="field.required?'required':''" class="form-control" :placeholder="field.placeholder" v-model="field.value"/>
                        <textarea v-if="field.type==1" :name="field.name + '_' + index + '_' + idx"  class="form-control" v-validate="field.required?'required':''" :placeholder="field.placeholder" v-model="field.value"></textarea>
                        
                        <div class="form-control radio-row" v-if="field.type==2">
                            <label v-for="(option,i) in field.options" :key="i">
                                <input type="radio" class=""  :name="field.name + '_' + index + '_' + idx"   :value="option" :checked="field.value==option?true:false" v-model="field.value"  v-validate="'required'"/>
                                {{option}}
                            </label>
                        </div>

                        <div class="form-control radio-row" v-if="field.type==3">
                            <label v-for="(option, i) in field.options" :key="i">
                                <input type="checkbox"  :name="field.name + '_' + index + '_' + idx"  class=""  :value="option"  :checked="field.value==option?true:false" v-model="field.value"  v-validate="'required'"/>
                                {{option}}
                            </label>
                        </div>

                        <div v-if="field.type==4">
                            <van-uploader v-model="item.fileList[idx]" :max-size="5 * 1024 * 1024" :before-read="beforeRead" @oversize="onOversize" :after-read="afterRead" :name="field.name+'_' + index + '_' + field.code" :ref="field.name + '_'+index + '_' + field.code"  max-count="1"/>
                        </div>

                        <span v-show="errors.has(field.name + '_' + index + '_' + idx)" class="error-text">{{errors.first(field.name + '_' + index + '_' + idx)}}</span>
                    </div>
                </div>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    报名组别：
                </div>
                <div class="control-input">
                    <select class="form-control" v-model="item.groupId" :name="'group'+index" v-validate="'required'">
                        <option hidden="true" disabled></option>
                       
                        <template v-for="(type, tindex) in station.groupTypes" v-if="type.status">
                            <option :value="type.typeId" :key="tindex" v-if="type.number == 0" selected>{{type.typeName}}</option>
                            <option :value="type.typeId" :key="tindex" v-else-if="(type.number - type.current) <= 0" disabled>{{type.typeName}}（报名人数已满）</option>
                            <option :value="type.typeId" :key="tindex" v-else  selected>{{type.typeName}}
                                <template v-if="type.showNumber">（剩余{{type.number-type.current}}）</template>
                            </option>
                        </template>
                        
                        
                    </select>

                    <span v-show="errors.has('group'+index)" class="error-text">{{errors.first('group' + index)}}</span>
                </div>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：
                </div>
                <div class="control-input">
                    <input type="text" class="form-control" placeholder="请输入您的备注" v-model="item.note"/>
                </div>
            </div>

            <div class="control-block row button-block">
                <button type="button" class="button button-danger" @click="deleteUser(index)" v-if="userList.length != 1">删除</button>
                <button type="button" class="button button-primary" @click="tempSave">保存</button>
            </div>

            <div class="control-block row add"  v-if="index == (userList.length-1)">
                <div class="control-label">
                    添加参赛者：
                </div>
                <div class="button-icon button-add" @click="addUser">
                    <img src="@/../static/tianjia.png" width="28px" />
                </div>
            </div>
        </div>

        <div class="intent-block urge-block">
            <div class="intent-title">
                <span><img src="@/../static/title_left.png"></span>
                紧急联系人
                <span><img src="@/../static/title_right.png"></span>
            </div>
            <div class="control-block row">
                <div class="control-label">
                    紧急联系人：
                </div>
                <div class="control-input">
                    <input type="text" v-validate="'required|name'" name="username" class="form-control" placeholder="请输入联系人的真实姓名"  v-model="urgency.username"/>
                    <span v-show="errors.has('username')" class="error-text">{{errors.first('username')}}</span>
                </div>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    手机号码：
                </div>
                <div class="control-input">
                    <input type="text" name="phone"  v-validate="'required|phone'" class="form-control" placeholder="请输入联系人手机号码" v-model="urgency.mobile"/>
                    <span v-show="errors.has('phone')" class="error-text">{{errors.first('phone')}}</span>

                </div>
            </div>

            <div class="control-block row">
                <div class="control-label">
                    电子邮箱：
                </div>
                <div class="control-input">
                    <input type="text" class="form-control" placeholder="请输入联系人电子邮箱(选填)" name="email" v-validate="'email'"  v-model="urgency.email"/>
                    <span v-show="errors.has('email')" class="error-text">{{errors.first('email')}}</span>
                </div>
            </div>

            
            <div class="control-block row button-block">
                <button type="button" class="button button-primary" @click="tempUrgeSave">保存</button>
            </div>
        </div>

        <div class="order-height"></div>

        <div class="order-block">
            <div class="order-price">合计：¥{{sumPrice}}</div>
            
            <van-loading v-if="isLoading" size="20" >报名中</van-loading>
            <button type="button" :disabled="isLoading" class="button button-primary"  id="btn-submit" @click="submitApply">
                
                <div id="templateBtn">
                    
                </div>
            </button>
             
            
        </div>

        <modal ref="noticeModal" title="免责声明"  btnText="确定" :helpText="station.notice"></modal>

        <modal ref="subscribeModal" title="重要提示"  btnText="知道了" helpText="请参赛选手点击“报名并支付”按钮时，务必允许订阅官方公众号发送的通知，以免错过重要的赛事消息！切记！切记！允许后方可成功报名"></modal>
    </div>
</template>

<script>
import Banner from "../components/MobileBanner"
import Modal from '../components/NoticeModal'
import Compressor from 'compressorjs'
import { MessageBox, Toast } from "mint-ui"
import wx from "weixin-js-sdk"


export default {
    components:{
        Banner, Modal
    },
    data(){
        return {
            isLoading:false,
            bannerList:[{
                mobileImageUrl:"/abc/static/banner.png"
            }],
            step:1,
            userList:[{
                username:"",
                cardType:0,
                cardNumber:"",
                sex:0,
                birthDay:"",
                mobile:"",
                note:"",
                feeId:[],
                groupId:"",
                fileList:[]
            }],
            urgency:{
                username:"",
                mobile:"",
                email:"",
                cardNumber:""
            },
            station: {},
            cardTypes:["身份证",  "护照", /*"驾驶证",*/ "港澳居民通行证", "台胞证"],
            wechatSign:{},
            openId:"",
            selectedDate:new Date('1990-01-01'),
            cityCode:'',
            wechatReady: false,
            code: "",
            type: "",
            isOpen: true,
            templateList: ""
        }
    },
    mounted(){
        document.title = "";
        this.cityCode = this.$route.query.cityCode;
        this.type = this.$route.query.type;
        let tempUser = localStorage.getItem("userList_"+this.cityCode);
        if(tempUser){
            this.userList = JSON.parse(tempUser);
        }
        let tempUrge = localStorage.getItem("urge_"+this.cityCode);
        if(tempUrge){
            this.urgency = JSON.parse(tempUrge);
        }
        //this.openId = "123"
        
        this.openId = localStorage.getItem("openId");
       
        this.getSettings();

        let self = this;
        wx.ready(function(){
            console.log("wechat ready!")
            self.getOpenId();
        });
        wx.error(function(res){
            self.isLoading = false
            MessageBox.alert("微信支付初始化失败" +  JSON.stringify(res));
            self.addLog(JSON.stringify(res), "微信支付初始化")
        }); 
        
        this.getWechatSign();
              
    },
    computed:{
        sumPrice:function(){
            let sum = 0.0;
            for(let i = 0 ; i < this.userList.length && this.station.fees; i++){
                let item = this.userList[i];
                if(item.feeId && item.feeId.length > 0){
                    for(let j = 0 ; j < item.feeId.length; j++){

                        for(let t = 0 ; t < this.station.fees.length; t++){
                            let fee = this.station.fees[t];
                            if(fee.feeId == item.feeId[j]){
                                sum += fee.price;
                            }
                        }

                    }
                }
            }
            return sum;
        }
    },
    watch:{
        userList:{
            handler(userList, oldVal){

                let phones = [];
                let cardNumbers = [];
                let self = this;

                for(let i = 0; i < userList.length; i++){
                    let user = userList[i];
                    if(user.cardType == 0 && user.cardNumber.length == 18){
                        //获取生日
                        let date = user.cardNumber.substring(6, 10) + '年' + user.cardNumber.substring(10, 12) + '月' + user.cardNumber.substring(12, 14) + "日";
                        user.birthDay = date;
                    }

                    if(user.mobile){
                        if(phones.includes(user.mobile)){
                            MessageBox.alert('手机号码不能相同');
                            self.isLoading = false;
                            return;
                        }else{
                            phones.push(user.mobile);
                        }
                    }

                    if(user.cardNumber){
                        if(cardNumbers.includes(user.cardNumber)){
                            MessageBox.alert('证件号码不能相同');
                            self.isLoading = false;
                            return;
                        }else{
                            cardNumbers.push(user.cardNumber);
                        }
                    }

                    if(user.birthDay && user.birthDay.length >= 11 && self.station.validAge){
                        let validDate = user.birthDay.substring(0,4) + "-" + user.birthDay.substring(5,7) + '-' + user.birthDay.substring(8,10);
                        if(self.station.endDate < validDate || self.station.startDate > validDate){
                            MessageBox.alert('您的年龄不符合。要求：' + self.station.startDate + " ~ " + self.station.endDate);
                            self.isLoading = false;
                            return;
                        }
                    }
 
                    

                }

                if(self.urgency.mobile && phones.includes(self.urgency.mobile)){
                    MessageBox.alert("紧急联系人电话不能与选手电话相同");
                    self.isLoading = false
                    return;
                }
            },
            deep:true
        }
    },
    methods:{
        beforeRead(file){
            return new Promise((resolve) => {
                // compressorjs 默认开启 checkOrientation 选项
                // 会将图片修正为正确方向
                let quality = 1;
                let size = file.size;
                if(size / 1024 > 512){
                    quality = (512*1024)/size;
                }

                new Compressor(file, {
                    quality: quality,
                    success(result){
                        let targetFile = new File([result], file.name, { type: file.type })
                        resolve(targetFile);
                    },
                    error(err) {
                        console.log(err.message);

                    },
                });
            });
        },
        onOversize(file) {
            console.log(file);
            Toast('文件大小不能超过 5MB');
        },
        afterRead(file, detail){
            console.log(file);
            console.log(detail)
            let self = this;
            let name = detail.name;
            let validType = 0;
            let names = name.split('_');
            if(names.length == 3){
                validType = names[2];
            }
           
            let fileAttr =[];
            if(!(file instanceof Array)){
                fileAttr.push(file);
            }else{
                fileAttr = file;
            }
            var formData = new FormData();
            for(let i = 0 ; i < fileAttr.length; i++){
                formData.append('filename', fileAttr[i].file.name);
                formData.append('file', fileAttr[i].file);
                formData.append('validType', validType);
                file.status = 'uploading';
                file.message = '上传中';
            }
    
            
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                    }
            };
            this.$http.post('/bicycle/inter/upload', formData, config).then(resp =>{
                console.log(resp);
                if(resp.data.status == 200){
                    let result = resp.data.data;
                    for(let i = 0 ; i < result.length; i++){
                        fileAttr[i]['url'] = result[i];
                        fileAttr[i]['status'] = 'done';
                    }
                    let field = undefined;
                    let temp = detail.name.split('_');
                    let fieldName = temp[0];
                    let index = temp[1];

                    for(let i = 0 ; i < this.userList[index].extra.length; i++){
                        if(this.userList[index].extra[i].name == fieldName){
                            field = this.userList[index].extra[i];
                        }
                    }
                    if(field){
                        let fileList = this.$refs[detail.name][0].fileList;
                        field.value = [];
                        for(let i = 0; i < fileList.length; i++){
                            field.value.push(fileList[i].url);
                        }
                    }
                     
                }else{
                    for(let i = 0 ; i < fileAttr.length; i++){
                        fileAttr[i]['status'] = 'fail';
                        fileAttr[i]['url'] = '';
                        fileAttr[i]['content']= '';
                    }
                    let temp = detail.name.split('_');
                    let fieldName = temp[0];
                    let index = temp[1];
                    for(let index = 0 ; index < self.userList.length; index++){
                        for(let i = 0 ; i < self.userList[index].extra.length; i++){
                            if(self.userList[index].extra[i].name == fieldName){
                                self.userList[index].extra[i].value = [];
                                
                            }
                        }
                    }
                    Toast(resp.data.errorMsg);
                }
            }).catch(err=>{
                console.log(err);
                for(let i = 0 ; i < fileAttr.length; i++){
                    fileAttr[i]['url'] = '';
                    fileAttr[i]['content']= '';
                    fileAttr[i]['status'] = 'fail';
                }
                for(let i = 0 ; i < self.userList[index].extra.length; i++){
                    if(self.userList[index].extra[i].name == fieldName){
                        self.userList[index].extra[i].value = [];
                        
                    }
                }
                 Toast('网络错误，请重试');
                 self.addLog(JSON.stringify(err), "上传图片")
            })
        },      
        setTitle:function(title){
            document.title = title;
            let i = document.createElement('iframe');
            i.src = '/wechat/images/nopng.png';
            i.style.display = 'none';
            i.onload = function(){
                setTimeout(function(){
                    i.remove();
                }, 9)
            }
            document.body.appendChild(i);
        },
        getSettings:function(){
            const self = this;
            this.$http.get("/bicycle/inter/intentSetting?cityCode="+this.cityCode+"&type="+this.type).then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    if(res.data.data.station.open == false){
                        MessageBox.alert("报名通道已关闭，不能报名");
                        return;
                    }
                  
                    self.station = res.data.data.station;

                    self.setTitle(self.station.name);


                    if(self.station.extra){
                        let extra = JSON.parse(self.station.extra);
                        if(self.station.extra){
                            self.station.extra = extra;
                        }

        
                        if(!self.userList[0].extra || self.userList[0].extra.length != extra.length){
                            
                            for(let i = 0 ; i < self.userList.length; i++){
                                self.userList[i].extra = self.station.extra;

                                self.formatExtraFieldValue(self.userList[i])
                            }
                            
                        }
                    }else{
                       
                        for(let i = 0 ; i < self.userList.length; i++){
                            self.userList[i].extra = [];

                            self.formatExtraFieldValue(self.userList[i])
                        }
                            
                        
                    }
                    if(self.station.file){
                        self.bannerList[0].mobileImageUrl = res.data.data.station.file;
                    }

                    if(self.station.notice){
                        self.station.notice = self.station.notice.replace(/\n/g, '<br>')
                        self.$refs.noticeModal.show();
                    }
                }
            }).catch(function(error){
                console.log(error)
                MessageBox.alert("您的网络不太好，请刷新重试")
                self.addLog(JSON.stringify(error), "获取站点基本信息")
            });
        },
        formatExtraFieldValue:function(userItem){
            for(let t = 0; t < userItem.extra.length; t++){
                let field =  userItem.extra[t];
                userItem.fileList.push([]);
                if(field.type == 3 || field.type == 4){
                    if(!field.value || field.value.length == 0){
                        field.value = [];
                    }
                }else{
                    field.value = "";
                }
            }
        },
        getWechatSign:function(){
            const self = this;
            let url = location.href;
            if(url.indexOf('#') > 0){
                url = url.substring(0, url.lastIndexOf('#'))
            }
            // url = location.protocol + "://" + location.hostname + location.pathname + 
            // "?cityCode=" + self.$route.query.cityCode + "&type=" + self.$route.query.type;
            let encodeUrl = encodeURIComponent(url);
            this.$http.get("/bicycle/inter/getWechatSign?url="+encodeUrl).then(function(res){
                if(res.data.status != 200){
                     MessageBox.alert(res.data.errorMsg);
                }else{
                    let e = res.data.data;

                    if(self.$route.query.code){
                        self.code = self.$route.query.code;
                        console.log(url)
                        wx.config({
                            debug: false, // 关闭调试模式
                            appId: e.appId, // 必填，公众号的唯一标识
                            timestamp: e.timestamp, // 必填，生成签名的时间戳
                            nonceStr: e.nonceStr, // 必填，生成签名的随机串
                            signature: e.signature,// 必填，签名
                            jsApiList: ['chooseWXPay','updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline'], 
                            openTagList: ['wx-open-subscribe', 'wx-open-launch-weapp']
                        });
                        //获取openId
                        if(!self.openId){
                            self.wechatReady = true;
                        }else{
                            self.wechatReady = true;
                        }
                        
                        // history.pushState({}, document.title, url);
                    }else{
                        let currentUrl =  location.origin + location.pathname + "?cityCode=" + self.$route.query.cityCode + "&type=" + self.$route.query.type;
                        let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +e.appId+ "&redirect_uri="+ encodeURIComponent(currentUrl)+"&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
                        window.location.href = redirectUrl;
                    }
                }
            }).catch(function(error){
                console.log(error)
                MessageBox.alert("您的网络不太好，请刷新重试")
                self.addLog(JSON.stringify(error), "获取微信签名")
            });
        },
        submitApply:function(){
            const self = this;
            try{
            this.$validator.validate().then(valid => {
                if(valid){
                            localStorage.setItem("userList_"+this.cityCode, JSON.stringify(this.userList));
                            localStorage.setItem("urge_"+this.cityCode, JSON.stringify(this.urgency));
                            const self = this;
                            this.isLoading = true;
                            this.saveOrder().then(data => {
                                let orderId = data; //订单编号
                                this.unifiedOrder(orderId).then(data =>{
                                    if(!self.wechatReady){
                                        this.isLoading = false
                                        MessageBox.alert("微信支付初始化失败");
                                    }else{

                                        wx.chooseWXPay({
                                            timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                                            nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                                            package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                                            signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                                            paySign: data.paySign, // 支付签名
                                            success: function (res) {
                                                // 支付成功后的回调函数
                                                localStorage.removeItem("userList_"+this.cityCode);
                                                localStorage.removeItem("urge_"+this.cityCode);
                                                this.isLoading = false
                                                MessageBox.alert("支付成功").then(action => {
                                                    //跳转到订单界面
                                                    let url = location.protocol + "//" + location.hostname + "/abc/intented?orderId="+orderId;
                                                    window.open(url)
                                                    //self.$router.push("/intented?orderId="+orderId);
                                                });
                                            },
                                            fail:function(err){
                                                MessageBox.alert("支付错误：" + JSON.stringify(err));
                                                this.isLoading = false
                                                this.addLog(JSON.stringify(err), "微信支付")
                                            }
                                        });
                                    }
                                }).catch(err=>{
                                    this.addLog(JSON.stringify(err), "统一下单错误");
                                    Message.alert("微信支付下单失败," + JSON.stringify(err))
                                });
                            }).catch(err=>{
                                this.addLog(JSON.stringify(err), "保存订单错误");
                                Message.alert("保存订单失败," + JSON.stringify(err))
                            })
                }else{
                    Toast('请填写正确的信息')
                }
            }).catch(err=>{
                self.addLog(JSON.stringify(error), "报名验证错误1");
            })
            }catch(error){
                self.addLog(JSON.stringify(error), "报名验证错误2");
            }

            
            
            
            
        },
        getOpenId:function(){
            const self = this;
            this.isLoading = true;
            self.$http.get("/bicycle/inter/getOpenId?code=" + self.code).then(function(res){
                    self.isLoading = false
                    if(res.data.status == 200){
                        //正常获取数据
                        self.openId = res.data.data;
                        localStorage.setItem("openId", self.openId);
                        self.wechatReady = true;
                        self.getTemplateList((template)=>{
                            self.templateList = [];
                            if(template && template.length){
                                for(let i = 0 ; i < template.length; i++){
                                    self.templateList += template[i].priTmplId + ","
                                }
                            }
                            if(self.templateList.length > 0){
                                self.templateList = self.templateList.substring(0, self.templateList.length-1)
                                self.createTemplate();
                            }

                            self.$refs.subscribeModal.show();
                        })
                    }else if(res.data.status == 302){
                        //用户刷新页面导致Code过期
                        let url = location.origin + location.pathname + "?cityCode=" + self.$route.query.cityCode + "&type=" + self.$route.query.type;
                        window.location.href = url
                    }else{
                        self.wechatReady = false
                        MessageBox.alert(res.data.errorMsg).then(action=>{
                            let url = location.origin + location.pathname + "?cityCode=" + self.$route.query.cityCode + "&type=" + self.$route.query.type;
                            window.location.href = url
                        });
                    }
                }).catch(function(error){
                    console.log(error)
                    self.isLoading = false
                    MessageBox.alert('错误，获取微信信息失败。请重新打开页面').then(action=>{
                        let url = location.origin + location.pathname + "?cityCode=" + self.$route.query.cityCode + "&type=" + self.$route.query.type;
                        window.location.href = url
                    });
                    self.addLog(JSON.stringify(error), "获取openId")
                });
        },
        saveOrder:function(){
            //保存订单
            const self = this;
            
            return new Promise((resolve, reject) => {
                try{
                    let userList = JSON.parse(JSON.stringify(self.userList));

                    let phones = [];
                    let cardNumbers = [];

                    for(let i = 0 ;  i < userList.length; i++){
                        if(userList[i].extra && userList[i].extra.length > 0){
                            for(let  t = 0; t < userList[i].extra.length; t++){
                                let e = userList[i].extra[t];
                                if(e.type == 4){
                                    if(e['required'] == 1 && e.value.length == 0){
                                        MessageBox.alert('请上传' + e.name);
                                        self.isLoading = false;
                                        return;
                                    }
                                }
                            };
                            userList[i].extra = JSON.stringify(userList[i].extra);
                        }

                        if(phones.includes(userList[i].mobile)){
                            MessageBox.alert('手机号码不能相同');
                            self.isLoading = false;
                            return;
                        }else{
                            phones.push(userList[i].mobile);
                        }

                        if(cardNumbers.includes(userList[i].cardNumber)){
                            MessageBox.alert('证件号码不能相同');
                            self.isLoading = false;
                            return;
                        }else{
                            cardNumbers.push(userList[i].cardNumber);
                        }

                        if(self.station.validAge){
                            if(userList[i].birthDay.length != 11){
                                MessageBox.alert('请输入完整的出生日期');
                                return;
                            }
                            let validDate = userList[i].birthDay.substring(0,4) + "-" + userList[i].birthDay.substring(5,7) + '-' + userList[i].birthDay.substring(8,10);
                            if(self.station.endDate < validDate || self.station.startDate > validDate){
                                MessageBox.alert('您的年龄不符合要求。要求：' + self.station.startDate + " ~ " + self.station.endDate);
                                self.isLoading = false;
                                return;
                            }
                        }
                        if(userList[i].cardType == 0){
                            let cardNumber = userList[i].cardNumber;
                            let date = cardNumber.substring(6, 10) + '-' + cardNumber.substring(10, 12) + '-' + cardNumber.substring(12, 14);
                            if(self.station.validAge && (self.station.endDate < date || self.station.startDate > date)){
                                MessageBox.alert('您的年龄不符合要求，请检查您的身份证号');
                                self.isLoading = false;
                                return;
                            }
                            console.log(date);
                            let bDate = userList[i].birthDay.substring(0,4) + "-" + userList[i].birthDay.substring(5,7) + '-' + userList[i].birthDay.substring(8,10);
                            console.log(bDate)
                            if(date != bDate){
                                MessageBox.alert('您的身份证号与出生日期不符合');
                                self.isLoading = false;
                                return;
                            }
                        }
                    }

                    if(phones.includes(self.urgency.mobile)){
                        MessageBox.alert("紧急联系人电话不能与选手电话相同");
                        self.isLoading = false
                        return;
                    }

                    console.log(userList);
                    let userData = JSON.parse(JSON.stringify(userList));
                    for(let i = 0 ; i < userData.length; i++){
                        userData[i].fileList = []
                    }
                    let params = {
                        "openId": self.openId,
                        "urge": self.urgency,
                        "userList": userData,
                        "code": self.cityCode
                    };
                    self.$http.post("/bicycle/inter/intentUser", params).then(function(res){
                        if(res.data.status != 200){
                            MessageBox.alert(res.data.errorMsg);
                            reject(res.data.errorMsg);
                            self.isLoading = false
                        }else{
                            resolve(res.data.data);
                        }
                    }).catch(function(error){
                        console.log(error)
                        self.isLoading = false
                        this.addLog(JSON.stringify(error), "保存订单")
                    });
                }catch(e){
                    MessageBox.alert("发生错误，请联系管理员")
                    this.addLog(JSON.stringify(e), "保存用户时报错")
                    reject("保存订单错误，" + JSON.stringify(e))
                };
            })
        },
        unifiedOrder:function(orderId){
            //统一下单
            const self = this;
            return new Promise((resolve, reject) => {
                self.$http.get("/bicycle/inter/unifiedOrder?orderNo=" + orderId + "&openId=" + self.openId).then(function(res){
                    if(res.data.status != 200){
                        MessageBox.alert(res.data.errorMsg);
                        reject(res.data.errorMsg);
                        self.isLoading = false
                    }else{
                        resolve(res.data.data);
                    }
                }).catch(function(error){
                    self.isLoading = false
                    console.log(error)
                    this.addLog(JSON.stringify(error), "统一下单")
                    MessageBox.alert("统一下单失败，网络错误");
                    reject("统一下单失败，网络错误")
                });
            })
        },
        createTemplate(){
            let self = this;
            let script1 = document.createElement('script');
            script1.type = "text/wxtag-template";
            script1.slot = "style";
            let style = "<style>"
            style += ".subscribe-btn{display:inline-block;color:white;width:108px;height:40px;font-size:15px;line-height:40px;text-align:center;}";
            style += "</style>"
            script1.innerHTML = style;

            let script2 = document.createElement('script')
            script2.type = "text/wxtag-template"
            script2.slot = "default"
            script2.innerHTML = '<div class="subscribe-btn">报名并支付</div>';

            let html = document.createElement('wx-open-subscribe');
            html.setAttribute("template", self.templateList);
            html.id = "sub-btn";

            html.appendChild(script1)
            html.appendChild(script2)
            
            let btn = document.getElementById("templateBtn");
            btn.appendChild(html)

            this.watchSub(html);
        },
        watchSub(btn){
            let self = this;
            btn.addEventListener('success', (e)=>{
                console.log("订阅了消息")
                self.submitApply();
            });
            btn.addEventListener('error', (e)=>{
                console.log("订阅错线作物")
                MessageBox.alert("订阅消息通知出现错误，请重试");
                self.addLog(JSON.stringify(error), "订阅消息出错")
            })
        },
        datePicker:function(index){
            this.$refs.picker[index].open();
        },
        dateConfirm:function(index){
            this.userList[index].birthDay = this.formatDate(this.selectedDate)
        },
        formatDate:function(secs){
            var t = new Date(secs)
            var year = t.getFullYear()
            var month = t.getMonth() + 1
            if (month < 10) { month = '0' + month }
            var date = t.getDate()
            if (date < 10) { date = '0' + date }
            var hour = t.getHours()
            if (hour < 10) { hour = '0' + hour }
            var minute = t.getMinutes()
            if (minute < 10) { minute = '0' + minute }
            var second = t.getSeconds()
            if (second < 10) { second = '0' + second }
            return year + '年' + month + '月' + date + '日'
        },
        addUser:function(){
            let userItem = {
                username:"",
                cardType:0,
                cardNumber:"",
                sex:0,
                birthDay:"",
                mobile:"",
                note:"",
                feeId:[],
                groupId:"",
                fileList:[],
                extra:this.station.extra
            }
            this.formatExtraFieldValue(userItem)
            this.userList.push(userItem);
            console.log(userItem)
        },
        deleteUser:function(index){
            if(this.userList.length <= 1){
                return;
            }
            this.userList.splice(index, 1);
        },
        tempSave:function(){
            localStorage.setItem("userList_"+this.cityCode, JSON.stringify(this.userList));
            Toast('保存成功');
        },
        tempUrgeSave: function(){
            localStorage.setItem("urge_"+this.cityCode, JSON.stringify(this.urgency));
            Toast('保存成功');
        },
        convertToChinaNum:function(num) {
            var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
            var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿');//可继续追加更高位转换值
            if(!num || isNaN(num)){
                return "零";
            }
            var english = num.toString().split("")
            var result = "";
            for (var i = 0; i < english.length; i++) {
                var des_i = english.length - 1 - i;//倒序排列设值
                result = arr2[i] + result;
                var arr1_index = english[des_i];
                result = arr1[arr1_index] + result;
            }
            //将【零千、零百】换成【零】 【十零】换成【十】
            result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
            //合并中间多个零为一个零
            result = result.replace(/零+/g, '零');
            //将【零亿】换成【亿】【零万】换成【万】
            result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
            //将【亿万】换成【亿】
            result = result.replace(/亿万/g, '亿');
            //移除末尾的零
            result = result.replace(/零+$/, '')
            //将【零一十】换成【零十】
            //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
            //将【一十】换成【十】
            result = result.replace(/^一十/g, '十');
            return result;
        }
    }
}
</script>

<style scoped>

.step-img{
    padding: 27px 42px;
}
.step-img img{
    width: 100%;
}
.intent-title{
    text-align: center;
    color: rgb(19, 124, 215);
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 25px;
}
.control-block{
    margin-top: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.control-label{
    color: rgb(102, 102, 102);
    font-size: 15px;
    float:left;
    width: 30%;
}
.control-input{
    width: 70%;
}
.form-control{
    border: 1px solid rgb(229, 229, 229);
    border-radius: 6px;
    height: 38px;
    color: rgb(51, 51, 51);
    font-size: 15px;
    padding: 0 14px;
    width: 100%;
    background: #fff;
}
.radio-inline{
    padding: 0 0;
    display: flex;
    align-items: center;
}
.radio-row{
    padding: 0 0;
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 7px 0;
}
.radio-row label{
    margin-left: 14px;
    padding: 7px 0;
}
.radio-inline input{
    margin-left: 14px;
}
.add{
    justify-content: start;
    margin-top: 35px
}
input,select,textarea{
    box-sizing: border-box;
}
textarea{
    min-height: 60px;
}
.button-block{
    margin-top: 35px;
}

.button-add:active{
    opacity: 0.7;
}

.order-height{
    height: 74px;
}
.order-block{
    background-color: #FFF;
    height: 64px;
    box-shadow: 2px -2px 5px #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}


.error-text{
    color:red;
    padding-left: 12px;
}

input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
  color: rgb(208, 208, 208);
  font-size: 15px;
}

input:-moz-placeholder, textarea:-moz-placeholder {
  color:rgb(208, 208, 208);
  font-size: 15px;
}

input::-moz-placeholder, textarea::-moz-placeholder {
  color: rgb(208, 208, 208);
  font-size: 15px;
}

input:-ms-input-placeholder, textarea:-ms-input-placeholder {
  color: rgb(208, 208, 208);
  font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/pages/MobileIntent.vue